// Session-cookie helper for the `token` cookie. Kept dependency-free:
// Utilities/Auth/index.tsx sits in an import cycle with useUser, and this
// module must be importable from both sides of it.
//
// On allstar.gg hosts the cookie is scoped to Domain=.allstar.gg so subdomains
// (e.g. developer.allstar.gg) can read the session. The legacy host-only
// cookie must be expired before the domain cookie is written — both can
// coexist, and the host-only one would shadow the domain one in
// document.cookie reads.

const COOKIE_DOMAIN = ".allstar.gg";
const EXPIRED = "expires=Thu, 01 Jan 1970 00:00:00 GMT";

const isAllstarHost = (hostname: string): boolean =>
  hostname === "allstar.gg" || hostname.endsWith(".allstar.gg");

export const sessionCookieStrings = (
  token: string,
  hostname: string,
): string[] => {
  if (!isAllstarHost(hostname)) {
    // localhost / previews: host-only, exactly as before
    return [`token=${token}; SameSite=None; Secure; path=/`];
  }
  return [
    `token=; ${EXPIRED}; SameSite=None; Secure; path=/`,
    `token=${token}; Domain=${COOKIE_DOMAIN}; SameSite=None; Secure; path=/`,
  ];
};

export const clearSessionCookieStrings = (hostname: string): string[] => {
  const hostOnly = `token=; ${EXPIRED}; SameSite=None; Secure; path=/`;
  if (!isAllstarHost(hostname)) return [hostOnly];
  return [
    hostOnly,
    `token=; ${EXPIRED}; Domain=${COOKIE_DOMAIN}; SameSite=None; Secure; path=/`,
  ];
};

export const setSessionCookie = (token: string): void => {
  for (const cookie of sessionCookieStrings(token, window.location.hostname)) {
    document.cookie = cookie;
  }
};

export const clearSessionCookie = (): void => {
  for (const cookie of clearSessionCookieStrings(window.location.hostname)) {
    document.cookie = cookie;
  }
};
